export const uiPerformanceTest = {
    testType: {
        chartConfig: {
            chart: {
                type: 'line',
            },
            plotOptions: {
                series: {
                    stacking: '',
                },
            },
            yAxis: [
                {
                    title: {
                        text: 'millis',
                    },
                },
            ],
        },
        group: 'UIPerformanceTestType',
        metrics: [
            {
                hidden: false,
                color: 'green',
                name: 'loadtime',
                title: 'Load Time',
                units: 'ms',
                id: 2,
                showInLegend: true,
                multiplier: 0,
                isString: false,
                isMain: true,
                string: false,
                main: true,
            },
        ],
        thresholds: [],
    },
};
